<h3>
    <span ng-bind-html="item.WorkflowName|cHighlight:highlight"></span>
</h3>
<span ng-bind-html="item.WorkflowDescription"></span>
<c-property-list properties="item.itemProperties" highlight="highlight"></c-property-list>
